export default __webpack_public_path__ + "static/media/ordersBasket.c57a891b.svg";